export default __webpack_public_path__ + "static/media/huayi.fa2d5c87.png";